import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { ThemeProvider } from "@mui/material";
import AgentManagement from "./AgentManagement";
import CssBaseline from "@mui/material/CssBaseline";
import theme from "../../assets/theme";
import "../../assets/base.css";

createRoot(document.getElementById("ahg-agent-management")).render(
	<StrictMode>
		<ThemeProvider theme={theme}>
			<CssBaseline />
			<AgentManagement />
		</ThemeProvider>
	</StrictMode>
);
